export default class WaterType {
    constructor({
        id = 0,
        name = ''
    } = {}) {
        this.id = id;
        this.name = name;
    }
}